import React, { FC } from "react";
import { getImage } from "gatsby-plugin-image";
import { useAppStoreIcons } from "@app/hooks/use-app-store-icons/useAppStoreIcons";
import { useViewVariant } from "@app/hooks/use-view-variant/useViewVariant";
import { useSiteData } from "@app/hooks";
import { DownloadAppProps } from "./types";
import { DownloadAppBody } from "./components/download-app-body/DownloadAppBody";

export const DownloadApp: FC<DownloadAppProps> = (props) => {
  const siteData = useSiteData();
  const { appStore, playMarket } = useAppStoreIcons();
  const appStoreIcon = getImage(appStore);
  const playMarketIcon = getImage(playMarket);
  const { isContentOnly } = useViewVariant();

  return isContentOnly ? null : (
    <DownloadAppBody
      {...{
        ...props,
        androidLink: siteData.androidLink,
        iosLink: siteData.iosLink,
        appStoreIcon,
        playMarketIcon,
      }}
    />
  );
};
